import React from 'react';

const Placeholder = ({image, text, description}) => {
  return (
    <div className="container__placeholder">
      <div className="container__placeholder_wrapper">
        <img src={`${process.env.PUBLIC_URL}/media/${image}.png`} alt={description} />
        <p>{text}</p>
      </div>
    </div>
  );
};

export default Placeholder;
